import React from 'react';
import { SnakShell } from '../SnakShell';
import { SnakStepView } from './SnakStepView';
import { products } from '../../data/products';
import { TOTAL_STEPS, toneForStep } from '../../utils/snakSteps';
const BASE_WIDTH = 344;
const BASE_HEIGHT = 688;
interface SnakSlideProps {
  step: number;
  /** Rendered width in pixels. The slide keeps the phone aspect ratio. */
  width: number;
  label: string;
}
const noop = () => undefined;

/** A static, non-interactive miniature of one Snak step. */
export function SnakSlide({
  step,
  width,
  label
}: SnakSlideProps) {
  const scale = width / BASE_WIDTH;
  return <div role="img" aria-label={label} className="overflow-hidden rounded-[26px] bg-[#FBF7F0]" style={{
    width,
    height: width * (BASE_HEIGHT / BASE_WIDTH)
  }} data-id="element-489" data-mp="8ngygbfllxo3">
      <div aria-hidden="true" className="pointer-events-none select-none" style={{
      width: BASE_WIDTH,
      height: BASE_HEIGHT,
      transform: `scale(${scale})`,
      transformOrigin: 'top left'
    }} data-id="element-490" data-mp="3c4z9ssukxmt9">
        <SnakShell tone={toneForStep(step, false)} step={step} total={TOTAL_STEPS} showProgress data-id="element-491" data-mp="ya6rixya061e">
          <SnakStepView step={step} order={products} role="middle" autoplayInterlude={false} onSelect={noop} onNext={noop} onRestart={noop} onDarken={noop} data-id="element-492" data-mp="ohhh86egoy7n" />
        </SnakShell>
      </div>
    </div>;
}